export const OPEN_MODAL = 'ksk001/wertermittler/OPEN_MODAL'
export const CLOSE_MODAL = 'ksk001/wertermittler/CLOSE_MODAL'

export const initialState = {
  isOpen: false,
  wasRendered: false,
}

export default (state = initialState, action) => {
  const { type } = action

  switch (type) {
    case OPEN_MODAL:
      return {
        ...state,
        isOpen: true,
        wasRendered: true,
      }
    case CLOSE_MODAL:
      return {
        ...state,
        isOpen: false,
      }
    default:
      return state
  }
}

export const openModal = () => dispatch => {
  dispatch({
    type: OPEN_MODAL,
  })
}

export const closeModal = () => dispatch => {
  dispatch({
    type: CLOSE_MODAL,
  })
}
